import type { AppRoute } from "@/lib/routing";
import { PurchasingPage } from "./pages/PurchasingPage";

export const routes: AppRoute[] = [
  {
    path: "/purchasing",
    element: <PurchasingPage />,
    handle: { title: "Purchasing", keywords: ["buy", "shopping", "basket", "orders", "can I make", "landed cost"] },
  },
  {
    path: "/purchasing/baskets/:id",
    lazy: async () => ({ Component: (await import("./pages/BasketPage")).BasketPage }),
    handle: { title: "Basket" },
  },
  {
    path: "/alerts",
    lazy: async () => ({ Component: (await import("./pages/AlertsPage")).AlertsPage }),
    handle: { title: "Alerts", keywords: ["price drop", "back in stock", "watches", "notifications", "wishlist"] },
  },
];
